export var ReservationsChart = {
    chart: {
        height: 280,
        type: 'line',
        toolbar: {
            show: false,
        },
    },
    colors: ['var(--theme-color4)', 'var(--theme-color5)'],
    stroke: {
        width: [3, 3],
        curve: 'smooth',
    },
    markers: {
        size: 4,
    },
    dataLabels: {
        enabled: false,
    },
    xaxis: {
        categories: []
    },
    yaxis: {
        title: {
            text: 'Bookings',
        },
    }
}
